import utilityfunctions from '../../util/utilityfunctions';

export default (countries) => {
	const sortCountries = utilityfunctions.sortListData(countries, 'countryName');
	let normalizeCountries = [];
	if (Array.isArray(sortCountries)) {
		normalizeCountries = sortCountries.map((country) => {
			return {
				label: country.countryName?.toString(),
				value: country.countryId,
				id: country.countryId,
				selected: false,
				disabled: false
			};
		});
	}
	return normalizeCountries;
};
